(function (root) {
  'use strict';
  function sizeOf(title) {
    const text = String(title || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const ounces = /\b(?:gallon|gal)\b/.test(text) ? 128 : Number(text.match(/\b(128|32|16|8|4|2)(?!\d)\s*(?:fl\.?\s*)?(?:oz|ounces?\b)?/)?.[1] || 0);
    return { ounces, pump: /\b(?:with|wth)\s+pump\b/.test(text) };
  }
  function chooseVariant(variants, size) {
    const choices = (variants || []).filter(v => size === 'all' || sizeOf(v.title).ounces === Number(size));
    return choices.find(v => v.available && !sizeOf(v.title).pump)
      || choices.find(v => v.available)
      || choices.find(v => !sizeOf(v.title).pump)
      || choices[0] || null;
  }
  function label(variant) {
    const size = sizeOf(variant?.title);
    return size.ounces === 128 ? `1 gal${size.pump ? ' + pump' : ''}` : size.ounces ? `${size.ounces} oz` : String(variant?.title || '');
  }
  function productUrl(handle, variant) {
    return `/products/${encodeURIComponent(handle)}${variant ? `?variant=${encodeURIComponent(variant.id)}#bto-buy` : ''}`;
  }
  root.BtoSizeRouting = { sizeOf, chooseVariant, label, productUrl };
})(typeof window === 'undefined' ? globalThis : window);
